import './domPolyfills'
import isString from 'lodash/isString'

export const getComponentsArrayBySelector = (selector) => {
  if (!selector || !isString(selector)) {
    // TODO: need to add assets
    console.error(`
      Error in function getComponentsArrayBySelector.
      Prop 'selector' is required with type string, but receive ${JSON.stringify(selector)} with type ${typeof selector}.
    `)

    return []
  }

  return Array.from(window.document.querySelectorAll(selector)) || []
}

export const changeElementClass = (element, className, isAdd = true) => {
  if (!element) {
    console.error(`Node element: ${element} is empty`)

    return element
  }

  if (isAdd) {
    element.classList.add(className)
  } else {
    element.classList.remove(className)
  }

  return element
}

export const getScrollParent = (node) => {
  if (node == null) {
    return null
  }

  if (node.scrollHeight > node.clientHeight) {
    return node
  } else {
    return getScrollParent(node.parentNode)
  }
}
